<template>
  <div>
    <div v-loading.fullscreen.lock="loading" class="msg_box clearfloat min_he600">
      <div v-show="!isShow" class="login_left">
        <p class="login_title">登录或注册一个新账号</p>
        <div class="login_zpz">
          <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" >
            <el-form-item label="用户名/email/手机" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="ruleForm.password" show-password></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="yzm">
              <el-input v-model="ruleForm.yzm">
                <template slot="append">
                  <canvas  id="canvas"  ref="yzm" @click="draw()" class="reg_yzm" ></canvas>
                </template>
              </el-input>
            </el-form-item>
            <div class="clearfloat">
              <button class="wxlogin" v-notClick="isTosub" @click="erwm">
                <span class="iconfont icon-weixin1"></span>微信快速登录
              </button>
            </div>
          </el-form>
          <div class="login_box">
            <span class="login_forget" @click="xin.goUrl('/forgetPwd')" >忘记账号密码？</span>
            <el-checkbox style="color: #444444" v-model="checked" >后续自动登录</el-checkbox>
            <button v-notClick="isTosub" class="laing_btn" @click="login">登录</button>
          </div>
        </div>
      </div>
      <div v-show="isShow" class="login_left">
        <div class="erm">
          <p class="login_title">手机扫码登录</p>
          <img :src="ewm" />
          <div class="zie">扫二维码关注公众号登录</div>
          <p class="laing" @click="onenErwm">Email/手机号登录</p>
        </div>
      </div>
      <div class="login_right">
        <p class="login_title">注册新账号</p>
        <p class="login_q">在同仁化学中国注册</p>
        <div>获取最新产品资讯与促销信息</div>
        <ul>
          <li><span>保存收藏夹和购物清单</span></li>
          <li><span>获取产品资讯和特别优惠</span></li>
          <li><span>订购产品</span></li>
          <li><span>注册用户专属客服</span></li>
        </ul>
        <button v-preventReClick class="laing_btn" @click="xin.goUrl('/register')">
          快速注册
        </button>
        <div class="login_bott">
          <div>我们不会公开您的信息</div>
          <div>如有任何问题请随时联系我们</div>
          <div>如需帮助，请发送邮件至info@dojindo.cn与我们联系。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chkPasswd } from "@/utlis/formrules";
import { mapMutations,mapActions} from "vuex";
export default {
  data() {
    return {
      loading:false,
      isTosub:true,
      ewm:'',
      timeId:-1,
      key:'',
      err:'',
      checked: true,
      isShow: false,
      yzms: "",
      lunxun:-1,//轮训定时器
      ruleForm: {
        name: "",
        password: "",
        yzm: "",
      },
      rules: {
        name: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [ { required: true, message: "请输入密码", trigger: "blur" }, ],
        yzm: { required: true, message: "请输入验证码", trigger: "blur" },
      },
    };
  },
  created() {},
  mounted() {
    this.draw();
  },
  beforeDestroy(){
  	clearTimeout(this.timeId);
  },
  methods: {
	...mapMutations(["settoken",'setisChecked']),
	...mapActions(['getUser']),
    async login() {//登录
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        if (this.yzms.toLowerCase() != this.ruleForm.yzm.toLowerCase()) {
          this.draw();
          this.$message({ message: "验证码错误", type: "warning" });
          this.ruleForm.yzm = "";
          return;
		}
		this.isTosub=false;
    this.loading = true;
    let { data, code, message } = await this.api.Postlogin(this.ruleForm);
    if (code == 200) {
      this.$message({ message: "登录成功", type: "success" });
      // this.setisChecked(this.checked);
      // if(this.checked) localStorage.setItem('GsToken','true')
      // else document.cookie = "GsToken=false; expires=Session"
      // this.xin.setCookie('GsToken','false',0)


		  this.settoken(data.token);
		  this.getUser();
		  if(this.$route.query.redirect)
			this.xin.goUrl(this.$route.query.redirect);
		  else
			this.xin.goUrl('/index');
      }else  {
      this.draw();
      this.ruleForm.yzm = '';
    }
		this.isTosub = true;
		this.loading = false;
      });
	},
	onenErwm(){//关闭二维码登录
		this.isShow = false;
		clearTimeout(this.timeId);
	},
	async erwm(){//获取二维码
	this.isTosub= false;
		let {code,data} = await this.api.Postewm({login:1});
			if(code==200){
				this.isShow = true;
				this.ewm = data.url;
				this.settime(data.key);
			}
			this.isTosub = true;
	},
  async settime(key) {//轮训
    let i =0;
		this.timeId = setInterval(async()=>{
      i++;
			let {code,data,message} = await this.api.Postgonzhohao({ key });
			if(code == 400){
			}else if(code==200){
				this.$message({ message: "登录成功!", type: "success" });
				clearTimeout(this.timeId);
				this.settoken(data.token);
				this.getUser();
				if(this.$route.query.redirect)
					this.xin.goUrl(this.$route.query.redirect);
				else
					this.xin.goUrl('/index');
			}else{
				this.onenErwm();
				this.err = message;
      }
      if(i>=100){
        this.onenErwm();
        this.$message({ message: "二维码已失效", type: "warning" });
      }
		},2000);
	},
    draw() {
      //生成并渲染出验证码图形 this.$refs.yzm.style.width
	  let show_num = [];
	  this.yzms = '';
      var canvas_width = 120;
      var canvas_height = 40;
      var canvas = this.$refs.yzm; //获取到canvas的对象，演员
      var context = canvas.getContext("2d"); //获取到canvas画图的环境，演员表演的舞台
      canvas.width = canvas_width;
      canvas.height = canvas_height;
      var sCode =  "a,b,c,d,e,f,g,h,i,j,k,m,n,p,q,r,s,t,u,v,w,x,y,z,A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
      var aCode = sCode.split(",");
      var aLength = aCode.length; //获取到数组的长度
      for (var i = 0; i < 4; i++) {
        //这里的for循环可以控制验证码位数（如果想显示6位数，4改成6即可）
        var j = Math.floor(Math.random() * aLength); //获取到随机的索引值
        // var deg = Math.random() * 30 * Math.PI / 180;//产生0~30之间的随机弧度
        var deg = Math.random() - 0.5; //产生一个随机弧度
        var txt = aCode[j]; //得到随机的一个内容
		    this.yzms = this.yzms+txt;
        show_num[i] = txt;
        var x = 10 + i * 20; //文字在canvas上的x坐标
        var y = 20 + Math.random() * 8; //文字在canvas上的y坐标
        context.font = "700 24px Arial";
        context.translate(x, y);
        context.rotate(deg);
        context.fillStyle = this.randomColor(50,160);
        context.fillText(txt, 0, 0);
        context.rotate(-deg);
        context.translate(-x, -y);
	  }
		
	//  
      for (var i = 0; i <= 5; i++) {
        //验证码上显示线条
        context.strokeStyle = this.randomColor(40,180);
        context.beginPath();
        context.moveTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        );
        context.lineTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        );
        context.stroke();
      }
      for (var i = 0; i <= 30; i++) {
        //验证码上显示小点
        context.strokeStyle = this.randomColor(0,255);
        context.beginPath();
        var x = Math.random() * canvas_width;
        var y = Math.random() * canvas_height;
        context.moveTo(x, y);
        context.lineTo(x + 1, y + 1);
        context.stroke();
      }
    },
    randomNum(min,max){
      return Math.floor( Math.random()*(max-min)+min);
    },
    randomColor(min,max) {
      //得到随机的颜色值
      var r = this.randomNum(min,max);
      var g = this.randomNum(min,max);
      var b = this.randomNum(min,max);
      return "rgb("+r+","+g+","+b+")";
    },
  },
};
</script>

<style lang="scss" scoped>
.msg_box {
  margin-top: 50px;
}
.login_title {
  font-size: 20px;
  color: #444444;
}
.login_left {
  width: 550px;
  // border: 1px solid;
  // width: 100%;
  .erm {
    text-align: center;
    .zie {
      color: #868788;
      font-size: 14px;
    }
    .laing {
      text-align: right;
    }
  }
  float: left;
  .login_zpz {
    width: 550px;
    padding-right: 125px;
    border-right: 1px solid #e1e1e1;
    .reg_yzm {
      width: 130px;
      height: 30px;
      cursor: pointer;
    }
  }
  .login_box {
    margin-top: 20px;
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 76px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    .login_forget {
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      color: #b03130;
    }
    .forget {
      color: #b03130;
    }
    .laing_btn {
      width: 110px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
    }
  }
  .yzm {
    font-size: 30px;
    float: right;
  }
  .wxlogin {
    cursor: pointer;
    float: right;
    color: #444444;
    font-size: 20px;
    .icon-weixin1 {
      margin-right: 10px;
      color: #64aa23;
      font-size: 20px;
    }
    &:hover {
      color: #0074d9;
    }
    .el-icon-platform-eleme {
      font-size: 20px;
    }
  }

  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #444444;
  }
  /deep/ .el-input-group__append,
  .el-input-group__prepend {
    background: #fff;
  }
  /deep/ .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}
.login_right {
  width: 390px;
  float: right;
  color: #444444;
  .login_bott {
    margin-top: 45px;
    div {
      padding: 8px 0;
    }
  }
  .laing_btn {
    margin-top: 50px;
    width: 200px;
    height: 40px;
    line-height: 40px;
  }
  ul {
    li {
      list-style: disc;
      color: #d73396;
      content: ".";
      span {
        color: #444444;
      }
    }
  }
  .login_q {
    margin: 30px 0;
    color: #444;
    font-size: 20px;
  }
}
</style>
